// extracted by mini-css-extract-plugin
module.exports = {"container":"_2ADuMkyHBpWHLUA1_Akvns","groupsList":"_2E8ULZRyuuew8ZxYYHOduf"};